import { render, staticRenderFns } from "./DistrictLocationsList.vue?vue&type=template&id=69d68c1c"
import script from "./DistrictLocationsList.vue?vue&type=script&lang=ts"
export * from "./DistrictLocationsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports